/* ==========================================================================
   LO - Scheda prodotto: comportamenti mobile
   --------------------------------------------------------------------------
   Caricato da snippets/lo-product-mobile.liquid (reso a sua volta da
   snippets/buy-buttons.liquid), quindi attivo su ogni template prodotto che
   usa la sezione main-product.

   Fa tre cose:
   1. su mobile porta titolo, stelle e prezzo sopra l'immagine, e li rimette
      al loro posto su desktop;
   2. costruisce la barra d'acquisto fissa in fondo allo schermo, spostandoci
      dentro il vero selettore quantita' e il vero messaggio d'errore del
      tema (nessuna logica duplicata);
   3. nasconde la sezione dei prodotti correlati se resta vuota.

   Nota: si inizializza una volta sola. buy-buttons puo' essere reso piu' di
   una volta nella stessa pagina (per esempio dentro una finestra di aggiunta
   rapida) e in quel caso il markup in piu' viene semplicemente ignorato.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__loProductMobileReady) return;
  window.__loProductMobileReady = true;

  var MOBILE_QUERY = '(max-width: 749px)';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  /* ---------------------------------------------------------------- head */

  function setupMobileHead(sectionId) {
    var head = document.getElementById('LoMobileHead-' + sectionId);
    var titleSlot = document.getElementById('LoMobileHeadTitle-' + sectionId);
    var priceSlot = document.getElementById('LoMobileHeadPrice-' + sectionId);
    if (!head || !titleSlot || !priceSlot) return;

    var anchors = [];
    var moved = false;

    function collect() {
      var info = document.getElementById('ProductInfo-' + sectionId);
      var container = document.getElementById('MainProduct-' + sectionId) || document;
      var titleNodes = [];
      var priceNodes = [];

      if (info) {
        // Solo il div esterno ".product__title": il tema ne annida un secondo
        // (<a class="product__title">) al suo interno.
        var title = info.querySelector(':scope > .product__title');
        if (title) titleNodes.push(title);
      }

      var rating = document.getElementById('LoRating-' + sectionId);
      if (rating) titleNodes.push(rating);

      var price = document.getElementById('price-' + sectionId);
      if (price) priceNodes.push(price);

      // "Imposte incluse" / link spedizione: nel tema e' un fratello del
      // prezzo, senza id, dentro #ProductInfo-<id>.
      if (info) {
        var tax = info.querySelector(':scope > .product__tax');
        if (tax) priceNodes.push(tax);
      }

      var volumeNote = document.getElementById('Volume-Note-' + sectionId);
      if (volumeNote) priceNodes.push(volumeNote);

      // "(N nel carrello)": nel tema sta dentro l'etichetta del selettore
      // quantita', che nella barra fissa non si vede piu'.
      var rulesCart = container.querySelector('.quantity__rules-cart');
      if (rulesCart) priceNodes.push(rulesCart);

      return { title: titleNodes, price: priceNodes };
    }

    function park(node, slot) {
      // Segnaposto invisibile, per rimettere l'elemento esattamente dov'era
      // quando si torna a desktop.
      var anchor = document.createComment('lo-head-anchor');
      node.parentNode.insertBefore(anchor, node);
      anchors.push({ anchor: anchor, node: node });
      slot.appendChild(node);
    }

    function moveUp() {
      if (moved) return;
      var container = document.getElementById('MainProduct-' + sectionId) || document;
      var grid = container.querySelector('.product.grid');
      var media = grid ? grid.querySelector('.product__media-wrapper') : null;
      if (!grid || !media) return;

      var nodes = collect();
      if (!nodes.title.length && !nodes.price.length) return;

      nodes.title.forEach(function (node) { park(node, titleSlot); });
      nodes.price.forEach(function (node) { park(node, priceSlot); });

      grid.insertBefore(head, media);
      head.classList.add('lo-mobile-head--active');
      moved = true;
    }

    function moveBack() {
      if (!moved) return;
      anchors.forEach(function (entry) {
        var parent = entry.anchor.parentNode;
        if (parent) {
          parent.insertBefore(entry.node, entry.anchor);
          parent.removeChild(entry.anchor);
        }
      });
      anchors = [];
      head.classList.remove('lo-mobile-head--active');
      moved = false;
    }

    function apply() {
      if (isMobile()) { moveUp(); } else { moveBack(); }
    }

    apply();
    window.addEventListener('resize', apply);
  }

  /* ------------------------------------------------------------ barra ATC */

  function setupStickyBar(sectionId) {
    var bar = document.getElementById('LoStickyAtc-' + sectionId);
    var stickyBtn = document.getElementById('LoStickyAtcBtn-' + sectionId);
    if (!bar || !stickyBtn) return;

    var stickyLabel = stickyBtn.querySelector('.lo-sticky-atc__btn-label');
    var priceOut = document.getElementById('LoStickyAtcPrice-' + sectionId);
    var variantOut = document.getElementById('LoStickyAtcVariant-' + sectionId);
    var qtySlot = document.getElementById('LoStickyAtcQtySlot-' + sectionId);
    var realBtnId = 'ProductSubmitButton-' + sectionId;
    var qtyFormId = 'Quantity-Form-' + sectionId;

    function scope() {
      return document.getElementById('MainProduct-' + sectionId) || document;
    }

    function reserveSpace() {
      if (!isMobile()) {
        bar.style.bottom = '';
        document.body.style.paddingBottom = '';
        return;
      }
      var nav = document.querySelector('.mobile-bottom-nav');
      var navHeight = (nav && nav.getBoundingClientRect().height) || 0;
      bar.style.bottom = navHeight + 'px';
      var barHeight = bar.getBoundingClientRect().height;
      document.body.style.paddingBottom = navHeight + barHeight + 'px';
    }

    // Prezzo valido adesso: quello scontato se il prodotto e' in saldo,
    // altrimenti quello pieno. Si legge dal nodo del tema, cosi' segue da
    // solo il cambio variante senza duplicare la logica dei prezzi.
    function readPrice() {
      var p = document.getElementById('price-' + sectionId);
      if (!p) return '';
      var el =
        p.querySelector('.price__sale .price-item--sale') ||
        p.querySelector('.price__regular .price-item--regular') ||
        p.querySelector('.price-item');
      return el ? el.textContent.trim() : '';
    }

    // Nome della variante selezionata, dai controlli reali del tema.
    // Stringa vuota se il prodotto ha una sola variante: in quel caso la
    // riga non compare affatto.
    function readVariant() {
      var vs = scope().querySelector('variant-selects');
      if (!vs) return '';
      var vals = Array.prototype.slice
        .call(vs.querySelectorAll('input[type="radio"]:checked'))
        .map(function (i) { return (i.value || '').trim(); });
      if (!vals.length) {
        vals = Array.prototype.slice.call(vs.querySelectorAll('select')).map(function (s) {
          return (s.value || '').trim();
        });
      }
      return vals.filter(Boolean).join(' / ');
    }

    // Porta nella barra il messaggio d'errore del tema, se e' ancora fuori.
    // Il tema puo' ricrearlo quando ridisegna il form al cambio variante.
    function adoptError() {
      var err = scope().querySelector('.product-form__error-message-wrapper');
      if (err && !bar.contains(err)) {
        bar.insertBefore(err, bar.firstChild);
        if (window.MutationObserver) {
          new MutationObserver(reserveSpace).observe(err, {
            attributes: true,
            attributeFilter: ['hidden']
          });
        }
      }
    }

    function syncInfo() {
      if (priceOut) priceOut.textContent = readPrice();
      if (variantOut) {
        var v = readVariant();
        variantOut.textContent = v;
        variantOut.hidden = !v;
      }
      adoptError();
      reserveSpace();
    }

    // Riancora la barra come figlio diretto di <body>: cosi' "position: fixed"
    // si aggancia davvero alla viewport, invece che al contenitore animato del
    // prodotto (che ha un transform CSS mentre esegue il reveal on scroll).
    document.body.appendChild(bar);
    bar.classList.add('lo-sticky-atc--active');

    // Sposta il vero selettore quantita' dentro la barra: stesso elemento,
    // nessuna duplicazione di logica.
    var qtyForm = document.getElementById(qtyFormId);
    if (qtyForm && qtySlot) qtySlot.appendChild(qtyForm);

    syncInfo();
    window.addEventListener('resize', reserveSpace);

    var priceEl = document.getElementById('price-' + sectionId);
    if (priceEl && window.MutationObserver) {
      new MutationObserver(syncInfo).observe(priceEl, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    var container = document.getElementById('MainProduct-' + sectionId);
    if (container) {
      container.addEventListener('change', function () {
        setTimeout(syncInfo, 80);
      });
    }

    try {
      if (
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.variantChange
      ) {
        subscribe(PUB_SUB_EVENTS.variantChange, function () {
          setTimeout(syncInfo, 80);
        });
      }
    } catch (e) {
      /* il tema non espone il pub/sub: bastano gli altri due agganci */
    }

    stickyBtn.addEventListener('click', function () {
      var realBtn = document.getElementById(realBtnId);
      if (realBtn) realBtn.click();
    });

    var realBtn = document.getElementById(realBtnId);
    if (realBtn && window.MutationObserver) {
      var syncButton = function () {
        stickyBtn.disabled = realBtn.disabled;
        var span = realBtn.querySelector('span');
        if (span && stickyLabel) {
          var text = span.textContent.trim();
          // Stato normale: solo la prima parola ("Aggiungi"), perche' a destra
          // c'e' il prezzo. Stato disabilitato (esaurito / non disponibile):
          // il messaggio intero.
          stickyLabel.textContent = realBtn.disabled ? text : text.split(' ')[0];
        }
        if (variantOut) {
          variantOut.hidden = realBtn.disabled || !variantOut.textContent;
        }
      };
      syncButton();
      new MutationObserver(syncButton).observe(realBtn, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }

  /* ------------------------------------------------- correlati vuoti */

  // <product-recommendations> chiede a Shopify i prodotti consigliati solo
  // quando entra nella viewport. Se Shopify non ne restituisce nessuno, il
  // tema lascia la sezione com'e': niente prodotti, niente titolo, ma i suoi
  // margini restano e si vede un buco.
  // Non si nasconde subito perche' a display:none la sezione non avrebbe piu'
  // dimensioni, non entrerebbe mai "in viewport" e la richiesta non
  // partirebbe affatto: si aspetta che arrivi a schermo, si da' al tema il
  // tempo di rispondere, e solo dopo si decide.
  function setupEmptyRecommendations() {
    var el = document.querySelector('product-recommendations');
    if (!el) return;
    var section = el.closest('.shopify-section') || el;
    var GRACE_MS = 3000;

    function verdict() {
      var empty = !el.querySelector('.grid__item, .product-card-wrapper, .card-wrapper');
      section.style.display = empty ? 'none' : '';
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(verdict, GRACE_MS);
    }

    if (window.MutationObserver) {
      new MutationObserver(verdict).observe(el, { childList: true, subtree: true });
    }

    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              schedule();
            }
          });
        },
        { rootMargin: '200px' }
      );
      io.observe(el);
    } else {
      schedule();
    }
  }

  /* ------------------------------------------------------------- avvio */

  function start() {
    var root = document.querySelector('.lo-product-mobile[data-lo-section]');
    if (!root) return;
    var sectionId = root.getAttribute('data-lo-section');
    if (!sectionId) return;

    setupMobileHead(sectionId);
    setupStickyBar(sectionId);
    setupEmptyRecommendations();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
